import * as React from 'react';
import { Switch } from '@cian/ui-kit/checkbox';
import { InlineText1, InlineText2 } from '@cian/ui-kit/typography';
import * as styles from './AutoProlong.mobile.css';

interface IAutoProlongMobileProps {
  value: boolean;
  isDisabled: boolean;
  hint: string;
  onChange(): void;
}

export const AutoProlongMobile = ({ value, isDisabled, hint, onChange }: IAutoProlongMobileProps) => {
  return (
    <div className={styles['wrapper']}>
      <div className={styles['auto-prolong']}>
        <InlineText1 color={isDisabled ? 'black_40' : 'black_100'}>Автопродление</InlineText1>
        <Switch data-name="AutoProlong" checked={value} disabled={isDisabled} onChange={onChange} />
      </div>

      <div className={styles['hint']}>
        <InlineText2 color="gray60_100">{hint}</InlineText2>
      </div>
    </div>
  );
};
